import { Button, Container, Input, Row, Select } from "@/components";
import { TInput } from "@/components/forms/form-elements/types";
import { FlexWrapper } from "@/components/layout/flex/flexWrapper";
import { useAxios } from "@/context/axiosContext";
import { useDialog } from "@/context/dialogContext";
import { useRedis } from "@/hooks/useRedis";
import { useState } from "react";
import DataTable, { TableColumn } from "react-data-table-component";
import { useLocation, useNavigate } from "react-router-dom";

interface DataRow {
  chnlId: string
  chnlNm: string
  chnlDesc: string
  useYn: string
}

const InsertYoutube: React.FC = () => {
  const axios = useAxios();
  const navigate = useNavigate();
  const location = useLocation();

  const { getComCodes, getComCodeValue } = useRedis();

  const { showAlert, showConfirm } = useDialog();

  const [data, setData] = useState<DataRow[]>([
    location.state?.data || {
      chnlDesc: '',
      chnlId: '',
      chnlNm: '',
      useYn: 'Y'
    }
  ]);

  const columns: TableColumn<DataRow>[] = [
    {
      name: '채널명',
      center: true,
      cell: (row, index) => {
        const idx = index;
        return <>
          <Input
            id={'chnlNm' + idx}
            name="chnlNm"
            value={row.chnlNm || ''}
            onChange={(e) => {
              handleRowChange(e, idx);
            }}
          />
        </>
      },
    },
    {
      name: '채널ID',
      center: true,
      cell: (row, index) => {
        const idx = index;
        return <>
          <Input
            id={'chnlId' + idx}
            name="chnlId"
            value={row.chnlId || ''}
            onChange={(e) => {
              handleRowChange(e, idx);
            }}
          />
        </>
      },
    },
    {
      name: '설명',
      center: true,
      cell: (row, index) => {
        const idx = index;
        return <>
          <Input
            id={'chnlDesc' + idx}
            name="chnlDesc"
            value={row.chnlDesc || ''}
            onChange={(e) => {
              handleRowChange(e, idx);
            }}
          />
        </>
      },
    },
    {
      name: '사용여부',
      center: true,
      selector: (row) => row.useYn,
      // sortable: true,
      cell: (row, index) => {
        const idx = index;
        return <>
          <Select
            id={'useYn' + idx}
            name="useYn"
            value={row.useYn}
            onChange={(e) => {
              handleRowChange(e, idx);
            }}
          >
            {getComCodes('USE_YN').map((item) => (
              <option key={'useYn' + idx + item.code} value={item.code}>
                {item.codeNm}
              </option>
            ))}
          </Select>
        </>
      },
      wrap: true,
      width: '10%',
    },
  ]

  const handleRowChange = (e: React.ChangeEvent<TInput>, idx: number) => {
    const { name, value } = e.target;

    setData(prevItems => {
      if (prevItems.length === 0) return prevItems; // 배열이 비어있으면 그대로 반환

      const newItems = [...prevItems]; // 기존 배열을 복사 (불변성 유지)
      newItems[idx] = { ...newItems[idx], [name]: value }; // 첫 번째 항목만 수정

      return newItems;
    })

  }

  const insertYoutube = async () =>  {
    const validationIdx = data.findIndex(youtube => ((youtube.chnlId && youtube.chnlId != '') && (!youtube.chnlNm || youtube.chnlNm == '')) || ((!youtube.chnlId || youtube.chnlId == '') && (youtube.chnlNm && youtube.chnlNm != '')));
    const param: DataRow[] = [];
    data.map((youtube, index) => {
      if(youtube.chnlId && youtube.chnlId != '' && youtube.chnlNm && youtube.chnlNm != ''){
        param.push(youtube);
      }
    });
    
    if(param.length == 0){
      const targetName = data[0].chnlNm == '' ? '채널명을' : '채널ID를';
      const targetTag = data[0].chnlNm == '' ? 'chnlNm0' : 'chnlId0';
      showAlert({
        type: 'warning',
        title: targetName + '입력해주세요',
        onClose() {
          document.getElementById(targetTag)?.focus();
        },
      })
      return;
    }

    if(validationIdx > -1){
      const targetName = data[validationIdx].chnlNm == '' ? '채널명을' : '채널ID를';
      const targetTag = data[validationIdx].chnlNm == '' ? 'chnlNm'+validationIdx : 'chnlId'+validationIdx;
      showAlert({
        type: 'warning',
        title: targetName + '입력해주세요',
        onClose() {
          document.getElementById(targetTag)?.focus();
        },
      })
      return;
    }

    if(!location.state?.data?.chnlId){
      const response: any = await axios.post('/youtube/insert', {channels: param},);
      if(response.status === 200 ){
        // TODO 성공코드값
        navigate('/youtube');
      }
    }else{
      param.push({chnlId: location.state?.data?.chnlId, chnlDesc: '', chnlNm: '', useYn: 'Y'});

      const response: any = await axios.post('/youtube/updateChannel', {channels: param},);
      if(response.status === 200 ){
        // TODO 성공코드값
        navigate('/youtube');
      }
    }

  };

  return (
    <>
      <div style={{ width: '100%', height: '100%', marginTop: '50px' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            marginBottom: '10px',
            alignItems: 'center',
            marginTop: '50px',
          }}
        >
          <p style={{ marginLeft: '20px', fontSize: '20px' }}>{location.state?.data ? `유튜브채널 수정` :`유튜브채널 등록`}</p>
          <FlexWrapper gap="20px">
            <Button
              onClick={() =>
                showConfirm({
                  title: '유튜브관리 화면으로 이동할까요?',
                  onConfirm() {
                    navigate('/youtube');
                  },
                })
              }
              color="neverbe"
              variant="outlined"
            >
              목록
            </Button>
            <Button
              onClick={() =>
                showConfirm({
                  title: '유튜브채널을 등록할까요?',
                  onConfirm() {
                    insertYoutube();
                  },
                })
              }
              color="neverbe"
            >
              저장
            </Button>
          </FlexWrapper>
        </div>
      </div>
      <Container>
        <Row>
          {
            !location.state?.data  &&
            <Button
              onClick={() => {
                setData([
                  ...data,
                  {
                    chnlDesc: '',
                    chnlId: '',
                    chnlNm: '',
                    useYn: 'Y'
                  }
                ]);
              }}
              color="neverbe"
            >
              추가
            </Button>
          }
        </Row>
      </Container>
      <DataTable
        columns={columns}
        data={data}
        // customStyles={tableStyles}
        noDataComponent={<div></div>}
      />
    </>
  );
};

export default InsertYoutube;